// What the assistant may send to the agent when a file is attached. The limits
// mirror the agent's `POST /rfas/from-screenshot` (360plus-agent api/routes/rfas.py).
export const ACCEPTED_FILE_TYPES =
  'image/png, image/jpeg, image/jpg, image/webp, image/gif, application/pdf';
export const MAX_FILE_BYTES = 15 * 1024 * 1024;
export const MAX_MESSAGE_CHARS = 2000;

export const draftPath = (projectId, rfaId) =>
  `/admin/projects/${projectId}/rfas/rfa/${rfaId}`;

// The agent read the file and declined to draft an RFA from it (agent-api.js
// flags this as `declined`). Say so, and ask for what would let it succeed.
const DECLINED_FILE_MESSAGE =
  "I couldn't make an RFA from that file. Add a short note about what you need and try again.";

// Only a 422 that carries no reason at all is a plain read failure; the agent's
// own reasons (unsupported type, too large, no text found) are shown as they are.
const UNREADABLE_FILE_MESSAGE =
  "I couldn't read that file. Try a clearer screenshot or a PDF.";

// Same wording rules as the RFA log's screenshot modal (agent-api.js
// explainScreenshotError).
export function friendlyFileError(status, errors, declined) {
  if (declined) {
    return DECLINED_FILE_MESSAGE;
  }
  const text = (errors && errors[0]) || '';
  if (status === 422 && !text) {
    return UNREADABLE_FILE_MESSAGE;
  }
  return text || "I couldn't create a draft from that file.";
}

// A failure worth offering "Try again" for: the agent was not reached, or it
// (or a service it depends on) said it was busy.
export const isRetryable = (status) =>
  status === null || [429, 502, 503, 504].includes(status);
